import { AppRegistry } from 'react-native';
import App from '../App.js';
import './styles.css';
import './vectorIconFonts';

const APP_NAME = 'QLBH';

AppRegistry.registerComponent(APP_NAME, () => App);

const rootTag = document.getElementById('root');
AppRegistry.runApplication(APP_NAME, { rootTag });
